import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import "react-toastify/dist/ReactToastify.min.css";
import "react-datetime/css/react-datetime.css";
import "react-image-lightbox/style.css";
import "./assets/css/custom-navbar.css";
import { ToastContainer, toast } from "react-toastify";
import { CloseButton, Fade } from "./components/common/Toast";
import Layout from "./layouts/Layout";
import Main from "./Main";

const App = () => {
  return (
    <Main>
      <Router basename={process.env.PUBLIC_URL}>
        <Layout />
        <ToastContainer
          transition={Fade}
          closeButton={<CloseButton />}
          position={toast.POSITION.BOTTOM_LEFT}
        />
      </Router>
    </Main>
  );
};

export default App;
